import { gql } from 'graphql-tag';
import { usePersistedQuery } from 'hooks/usePersistedQuery';
import { useSearchInput } from 'hooks/useSearchInput';

export const GET_ANNUAL_TICKETS = gql`
  query GetAllAnnualTickets($getAnnualTicketsInput: GetAnnualTicketsInput!) {
    getAllAnnualTickets(input: $getAnnualTicketsInput) {
      count
      results {
        id
        series {
          id
          name
        }
        tracks {
          id
          name
        }
        account {
          id
          business_dba
        }
        ticket {
          id
          name
          sale_end
        }
        name
        status
        events {
          id
          name
        }
      }
    }
  }
`;

export function useGetAllAnnualTickets(
  accountFilter,
  isPurchase,
  userType,
  annualType,
  annualEvent,
  year
) {
  const { input: search } = useSearchInput();

  // Filter out account_id from search params - it's handled via accountFilter prop
  // eslint-disable-next-line no-unused-vars
  const { account_id, ...filteredSearch } = search;

  const result = usePersistedQuery(
    GET_ANNUAL_TICKETS,
    `annual-tickets-${accountFilter}-${filteredSearch.queryString}-${
      isPurchase ? isPurchase : null
    }-${annualType ? annualType : null}`,
    {
      variables: {
        getAnnualTicketsInput: {
          ...filteredSearch,
          ...(accountFilter ? { accountFilter } : null),
          ...(isPurchase ? { isPurchase } : null),
          ...(annualType ? { annualType: annualType.value } : null),
          ...(annualEvent ? { event_id: annualEvent } : null),
          ...(year ? { year: year } : null),
        },
      },
      fetchPolicy: 'cache-and-network',
      skip: userType === 'track' ? !accountFilter : false,
    }
  );

  return { ...result, res: result.data };
}
